<script>
  import { onMount, tick } from 'svelte';
  import Splide from '@splidejs/splide';
  import '@splidejs/splide/dist/css/splide.min.css';

  export let data = [];
  let testimonials = [];
  let splideEl;

  onMount(async () => {
    testimonials = data;
    await tick();
    new Splide(splideEl, {
      type: 'fade',
      rewind: true,
      speed: 1000,
      autoplay: true,
      pauseOnHover: true,
      arrows: true,
    }).mount();
  });
</script>

<div class="splide" bind:this={splideEl}>
  <div class="splide__track">
    <ul class="splide__list">
      {#each testimonials as t}
        <li class="testi splide__slide">
            <div class="testi-content"><blockquote class="quote">{t.quote}<br><strong>{t.name}</strong></blockquote></div>
            {#if t.photo}
              <div class="testiphoto">
                <img
                  class="photo"
                  src={t.photo}
                  srcset={t.photoSrcset}
                  sizes={t.photoSizes || '100vw'}
                  width={t.photoWidth}
                  height={t.photoHeight}
                  loading={t.isPriority ? 'eager' : 'lazy'}
                  fetchpriority={t.isPriority ? 'high' : undefined}
                  decoding="async"
                  alt={t.name}
                />
              </div>
            {/if}
        </li>
      {/each}
    </ul>
  </div>
</div>

<style lang="scss">
  .testi {
    padding: 0;
    text-align: center;
    height: 60vh;
    display: flex;
    align-items: center;
  }
  
  .testiphoto {
    width: 100%;
    height: 100%;
    position: absolute;
  }
  .testiphoto img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .testi-content { 
    display: flex;
    align-items: center;
    width: 50%;
    height: 100%;
    margin-left: 2rem;
    z-index: 3;
    text-align: left;
  }
  blockquote:before { 
    left: -.5rem;
  }
  .quote {
    color: #FFF;
    padding: 2rem 2rem 2rem 2.75rem;
    font-size: 1.1rem;
    line-height: 1.7;
    font-style: italic;
    background-color: rgba(0,0,0,.8);
  }

  @media (max-width: 600px) {
    .testi-content { 
      width: 100%;
      margin-left: 0px;
    }
  }

</style>